import z from "zod";

export const SendFeedbackSchema = z.object({
  message: z
    .string()
    .trim()
    .min(1, "Message is required")
    .max(5000, "Message must be 5000 characters or less"),
  page: z.string().trim().min(1).max(500),
  attachments: z
    .array(z.instanceof(File))
    .max(3, "At most 3 attachments")
    .optional(),
});
export type SendFeedbackInput = z.input<typeof SendFeedbackSchema>;
export type SendFeedbackDto = z.infer<typeof SendFeedbackSchema>;
